/// <reference path="./vite-env.d.ts" />

// Log version on load
console.log("Mixhalo SDK version:", __APP_VERSION__, "hash:", __GIT_HASH__);

// Expose version and git hash globally for HTML access
if (typeof window !== "undefined") {
  (window as any).__MIXHALO_SDK_VERSION__ = __APP_VERSION__;
  (window as any).__MIXHALO_SDK_GIT_HASH__ = __GIT_HASH__;
}

export * from "./types/error.types";
export * from "./types/model.types";
export * from "./services/api";
export * from "./services/player";
export * from "./services/audio-text-decoder";
export * from "./services/audio-graph";
export * from "./utils/session-helpers";
export * from "./utils/location";
export * from "./utils/type-helpers";
export { createPlayer, getPlayer } from "./services/native-player";
export { createApi, getApi } from "./services/api";
export { initializeMixhalo } from "./mixhalo-native-sdk";
export { debugConfig } from "./utils/debug-config";
export { audioDumper } from "./utils/audio-dumper";
// Note: OpusDecoder removed from re-exports to avoid SSR issues
// Import directly from 'opus-decoder' if needed
export * as Tone from "tone";
